// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-container-main {
  margin: 3%;
}
.video-container-main h3 {
  padding-bottom: 2%;
}
.video-container {
  display: grid;
  grid-template-columns: 60% 40%;
  grid-column-gap: 20px;
}

/* Between the mobile carousel breakpoint (767px) and desktop, a 60/40 split
   leaves both columns too cramped to be useful — stack instead. */
@media (max-width: 991px) {
  .video-container {
    grid-template-columns: 1fr;
    grid-row-gap: 16px;
  }
}

.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}

.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

/* Mobile: show 4 videos in equal size */
.video-equal-stack {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.video-equal-responsive {
  overflow: hidden;
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #000;
}

.video-equal-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

.video-item {
  display: flex;
  align-items: center;
  margin: 15px;
}
.video-item :hover {
  cursor: pointer;
}
.avatar-caption {
  padding: 10px;
}
.video-item p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/Video.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;kEACkE;AAClE;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX","sourcesContent":[".video-container-main {\n  margin: 3%;\n}\n.video-container-main h3 {\n  padding-bottom: 2%;\n}\n.video-container {\n  display: grid;\n  grid-template-columns: 60% 40%;\n  grid-column-gap: 20px;\n}\n\n/* Between the mobile carousel breakpoint (767px) and desktop, a 60/40 split\n   leaves both columns too cramped to be useful — stack instead. */\n@media (max-width: 991px) {\n  .video-container {\n    grid-template-columns: 1fr;\n    grid-row-gap: 16px;\n  }\n}\n\n.video-responsive {\n  overflow: hidden;\n  padding-bottom: 56.25%;\n  position: relative;\n  height: 0;\n}\n\n.video-responsive iframe {\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n/* Mobile: show 4 videos in equal size */\n.video-equal-stack {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 14px;\n}\n\n.video-equal-responsive {\n  overflow: hidden;\n  position: relative;\n  height: 0;\n  padding-bottom: 56.25%;\n  border-radius: 16px;\n  border: 1px solid #e5e7eb;\n  background: #000;\n}\n\n.video-equal-responsive iframe {\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n.video-item {\n  display: flex;\n  align-items: center;\n  margin: 15px;\n}\n.video-item :hover {\n  cursor: pointer;\n}\n.avatar-caption {\n  padding: 10px;\n}\n.video-item p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
